import { Link } from 'react-router-dom';
import classNames from 'classnames';

import './style.scss';

const LinkButton = ({ href, children, variant = 'orange', className = '' }) => {
    return (
        <Link to={href} className={classNames(
            'button-link',
            `btn-${variant}`,
            className
        )}>
            {children}
            <svg
                width="12"
                height="12"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className='icon-right'
            >
                <mask
                    id="mask0_1491_5859"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="13"
                    height="13"
                >
                    <path
                        d="M12.16 0.261719H0.160034V12.2617H12.16V0.261719Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask0_1491_5859)">
                    <path
                        d="M6.18899 6.29727L0.157349 0.265625L-5.87427 6.29725L0.157368 12.3289L6.18899 6.29727Z"
                        stroke="white"
                        strokeWidth="1.6"
                        strokeMiterlimit="10"
                    />
                </g>
            </svg>
        </Link>
    );
};

export default LinkButton;
